import { Component, ElementRef, Output, EventEmitter, Input, AfterViewInit } from '@angular/core';
import { Loader } from '@googlemaps/js-api-loader';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-google-maps',
  templateUrl: './google-maps.component.html',
  styleUrls: ['./google-maps.component.scss'],
})
export class GoogleMapsComponent implements AfterViewInit {

  @Input() styleAttr?: string;
  @Output() mapReady = new EventEmitter<google.maps.Map>();
  @Output() mapError = new EventEmitter<any>();

  constructor(private el: ElementRef) { }

  ngAfterViewInit() {
    // Wait a few ticks to make sure the containing div has a defined width/height; otherwise
    // map is grayed-out.
    setTimeout(async () => {
      try {
        await new Loader({ apiKey: environment.GOOGLE_MAPS, version: 'quarterly' }).load();
        this.mapReady.emit(new google.maps.Map(this.el.nativeElement.children[0]));
      } catch (e) {
        this.mapError.emit(e);
      }
    }, 1000);
  }
}
